import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-title",
  "use": "icon-title-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-title\"><path d=\"M192 320h256V160a32 32 0 0 1 64 0v384a32 32 0 0 1-64 0v-160H192v160a32 32 0 0 1-64 0V160a32 32 0 1 1 64 0v160z m448 108.288l-17.248 17.248a32 32 0 0 1-45.248-45.28l67.872-67.84c1.696-1.696 3.52-3.136 5.408-4.384A32 32 0 0 1 704 352v192a32 32 0 0 1-64 0v-115.712zM96 672h832a32 32 0 0 1 0 64H96a32 32 0 0 1 0-64z m0 160h704a32 32 0 0 1 0 64H96a32 32 0 0 1 0-64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol